"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var runescape_png_1 = __importDefault(require("./assets/runescape.png"));
var runescape_round_png_1 = __importDefault(require("./assets/runescape-round.png"));
var oldschool_png_1 = __importDefault(require("./assets/oldschool.png"));
var jagex_svg_1 = __importDefault(require("./assets/jagex.svg"));
var LOGOS;
(function (LOGOS) {
    LOGOS[LOGOS["RUNESCAPE"] = 0] = "RUNESCAPE";
    LOGOS[LOGOS["RUNESCAPE_ROUND"] = 1] = "RUNESCAPE_ROUND";
    LOGOS[LOGOS["OLDSCHOOL"] = 2] = "OLDSCHOOL";
    LOGOS[LOGOS["JAGEX"] = 3] = "JAGEX";
})(LOGOS = exports.LOGOS || (exports.LOGOS = {}));
exports.Logo = function (_a) {
    var logo = _a.logo;
    var logoFile;
    var altText = "RuneScape";
    switch (logo) {
        case LOGOS.RUNESCAPE:
            logoFile = runescape_png_1.default;
            break;
        case LOGOS.RUNESCAPE_ROUND:
            logoFile = runescape_round_png_1.default;
            break;
        case LOGOS.OLDSCHOOL:
            logoFile = oldschool_png_1.default;
            altText = "Old School RuneScape";
            break;
        case LOGOS.JAGEX:
            logoFile = jagex_svg_1.default;
            altText = "Jagex";
            break;
    }
    return react_1.default.createElement("img", { alt: altText, src: logoFile });
};
